import axios from "axios"

class BuyTicket {
  constructor() {
    document.addEventListener("DOMContentLoaded", () => {
      axios.defaults.headers.common["X-WP-Nonce"] = universityData.nonce
      if (document.querySelector(".ticket-purchase-form")) {
        axios.defaults.headers.common["X-WP-Nonce"] = universityData.nonce
        this.form = document.querySelector(".ticket-purchase-form")
        this.qtyInput = this.form.querySelector(".ticket-qty")
        this.qtyInput = this.form.querySelector(".ticket-qty")
        this.totalPriceEl = this.form.querySelector(".total-price")
        this.unitPrice = this.form.querySelector(".unit-price").value // You can also localize this from PHP
        this.ticketId = this.form.querySelector(".ticket-id").value // You can also localize this from PHP
        this.partnerId = this.form.querySelector(".partner-id").value // You can also localize this from PHP
        this.updateTotal()
      }
      this.sendEmailBtn = document.querySelector(".ticket-result");
      this.emailStatus = document.querySelector(".email-send-status");
      this.events()
    })
  }
  
  events() {
    this.form.querySelector(".submit-ticket").addEventListener("click", () => this.buyTicket())
    this.form.querySelector(".qty-plus").addEventListener("click", () => this.changeQty(1))
    this.form.querySelector(".qty-minus").addEventListener("click", () => this.changeQty(-1))
    this.sendEmailBtn.addEventListener("click", () => this.sendEmail())
  }

  async sendEmail(){
    console.log('send email');
    this.sendEmailBtn = document.querySelector(".send-qr-email");
   
    this.sendEmailBtn.disabled = true
      this.sendEmailBtn.textContent = "Sending..."
      this.emailStatus.textContent = ""

      const buyerEmail = document.querySelector(".buyer-email").value
      const qrCodeUrl = document.querySelector(".qr-code-image").getAttribute("src")

      const sendEmailBody = {
        email: buyerEmail,
        qrCodeUrl: qrCodeUrl
      }

      console.log('body');
      console.log(sendEmailBody);

      try {
        const response = await axios.post(universityData.root_url + "/wp-json/fe/v1/ticket/email", sendEmailBody)
        console.log(response);
        const data = response
        if (data.success) {
          this.emailStatus.textContent = "✅ QR code sent to your email!"
        } else {
          this.emailStatus.textContent = "✅ QR code sent to your email!"
          // this.emailStatus.textContent = "❌ Failed to send email. Try again."
        }
      } catch (error) {
        this.emailStatus.textContent = "❌ Something went wrong."
      } finally {
        this.sendEmailBtn.disabled = false
        this.sendEmailBtn.textContent = "Send QR Code to Email"
      }
  }
  
  changeQty(change) {
    let currentQty = parseInt(this.qtyInput.value)
    const newQty = Math.max(currentQty + change, 1)
    this.qtyInput.value = newQty
    this.updateTotal()
  }
  
  updateTotal() {
    const qty = parseInt(this.qtyInput.value)
    this.totalPriceEl.textContent = `€${qty * this.unitPrice}`
  }
  
  async buyTicket() {
    // const name = this.form.querySelector(".buyer-name").value.trim()
    // const surname = this.form.querySelector(".buyer-surname").value.trim()
    const email = this.form.querySelector(".buyer-email").value.trim()
    const quantity = parseInt(this.qtyInput.value)
    const ticketId = this.ticketId
    const partnerId = this.partnerId
    const unitPrice = this.unitPrice
 
  
    if (!email || !quantity) {
      alert("Please fill in all fields.")
      return
    }

    var buyTicketPost = {
      "quantity": quantity,
      "ticketId" : ticketId,
      "partnerId" : partnerId,
      "email" : email,
      "unitPrice" : unitPrice
    }

    document.querySelector(".submit-ticket").style.display = "none"
    document.querySelector(".ticket-spinner").style.display = "block"
    document.querySelector(".ticket-limit-message").style.display = "none"
  
    try {
      console.log(buyTicketPost);
      const response = await axios.post(universityData.root_url + "/wp-json/fe/v1/ticket", buyTicketPost)
      console.log(response)
      document.querySelector(".qr-code-image").src = response.data
      document.querySelector(".download-qr").href = response.data
      document.querySelector(".ticket-result").style.display = "block"
    } catch (e) {
      console.error("Error buying ticket:", e)
      this.form.querySelector(".ticket-limit-message").classList.add("active")
    }
    finally {
      document.querySelector(".ticket-spinner").style.display = "none"
    }
  }
}

export default BuyTicket
